import { lazy } from 'solid-js'
import { messages } from '../../pages/privacy-page/privacy-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/privacy-page/privacy-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/privacy-policy',
    titleMessage: messages.titleMessage,
}
